import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "booking-summary"
}
const _hoisted_3 = { class: "booking-summary--car" }
const _hoisted_4 = { class: "booking-summary--car-image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "booking-summary--car-info" }
const _hoisted_7 = { class: "booking-summary--car-info-class" }
const _hoisted_8 = { class: "booking-summary--car-info-capacity" }
const _hoisted_9 = { class: "car-icon-pax" }
const _hoisted_10 = { class: "car-icon-bags" }
const _hoisted_11 = { class: "booking-summary--card" }
const _hoisted_12 = { class: "booking-summary--card-map" }
const _hoisted_13 = { class: "booking-summary--card-address" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Pick up address", -1)
const _hoisted_16 = { class: "form-control-value" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Dropoff address", -1)
const _hoisted_20 = { class: "form-control-value" }
const _hoisted_21 = { class: "booking-summary--card booking-summary--card-notes" }
const _hoisted_22 = { class: "form-group-horizontal" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Name on meeting sign", -1)
const _hoisted_24 = { class: "form-control-value" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_26 = { class: "form-group-horizontal" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "Date & time", -1)
const _hoisted_28 = { class: "form-control-value" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1)
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "special note", -1)
const _hoisted_32 = { class: "form-control-value font-weight-300" }
const _hoisted_33 = { class: "booking-summary--price" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "booking-summary--price-text" }, "Total Amount due", -1)
const _hoisted_35 = { class: "booking-summary--price-amount" }
const _hoisted_36 = ["onClick", "disabled"]

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useBookNowSummary } from '@/store/book-now'
import { formatDate } from '@/mixins/date'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookSummary',
  setup(__props) {

const router = useRouter()

const map = ref<google.maps.Map>()
const mapDiv = ref<HTMLDivElement | undefined>()

const { form, selectedVehicleCat, saveBooking, isPending } = useBookNowSummary()
const onSubmit = async () => {
  const { id, hash } = await saveBooking()
  router.push({ name: 'book_payment', params: { id, hash } })
}

const createMap = () => {
  if (!mapDiv.value) {
    return;
  }

  const center: google.maps.LatLngLiteral = {
    lat: 53.35014,
    lng: -6.266155,
  };

  map.value = new google.maps.Map(mapDiv.value, {
    center,
    zoom: 8,
    fullscreenControl: false,
  });

  const bounds = new google.maps.LatLngBounds();
  const markers: google.maps.Marker[] = [];

  const { pickupLat, pickupLng, destinationLat, destinationLng } = form.value
  if (pickupLat && pickupLng) {
    const position: google.maps.LatLngLiteral = {
      lat: pickupLat,
      lng: pickupLng,
    };

    const marker = new google.maps.Marker({
      position,
      map: map.value,
    });

    markers.push(marker)
    bounds.extend(position)
  }

  if (destinationLat && destinationLng) {
    const position: google.maps.LatLngLiteral = {
      lat: destinationLat,
      lng: destinationLng,
    }

    const marker = new google.maps.Marker({
      position,
      map: map.value,
    })

    markers.push(marker)
    bounds.extend(position)
  }

  if (markers.length > 1) {
    map.value.fitBounds(bounds)
  } else {
    map.value.panTo(bounds.getCenter())
    map.value.setZoom(15)
  }
}

onMounted(createMap)

return (_ctx: any,_cache: any) => {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppHeaderProgressBar = _resolveComponent("AppHeaderProgressBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AppHeader, {
      title: "booking summary",
      steps: [3, 3],
      "back-route-to": { name: 'book_select_car' }
    }),
    _createVNode(_component_AppHeaderProgressBar, {
      from: 0,
      to: 100
    }),
    _createElementVNode("div", _hoisted_1, [
      (_unref(selectedVehicleCat))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _unref(selectedVehicleCat).vehicleCat.image
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(selectedVehicleCat).vehicleCat.name), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(selectedVehicleCat).vehicleCat.capacity), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(selectedVehicleCat).vehicleCat.bags), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "booking-details-map",
                  ref_key: "mapDiv",
                  ref: mapDiv
                }, null, 512)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(form).pickup), 1)
                ]),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(form).destination), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(form).clientRef1), 1)
              ]),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(formatDate)(_unref(form).jobDate, "DD/MM/YYYY")) + ", " + _toDisplayString(_unref(form).jobTime), 1)
              ]),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(form).pickupInstructions), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(selectedVehicleCat).booking.priceFormatted), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-block booking-summary--paybycard-btn",
              onClick: _withModifiers(onSubmit, ["prevent"]),
              disabled: _unref(isPending)
            }, " Pay by card ", 8, _hoisted_36)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})